import { ProviderHelperClient } from '~/plugins/data-connector/helpers/provider.helper.client'
import { ProviderClientProperty } from '~/plugins/data-connector/types/provider.types'
import { Oauth2CommonType } from './oauth2.common'

type OptionsClient = Oauth2CommonType & {
  clientId?: string
  inputs?: ProviderClientProperty[]
}

type ResponseClient = Oauth2CommonType & {
  inputs?: ProviderClientProperty[]
  clientId: string
}

export function Oauth2Client(options: OptionsClient): ResponseClient {
  const clientId =
    options.clientId ??
    ProviderHelperClient.getEnvVariable(options.key, 'CLIENT_ID')

  return {
    ...options,
    clientId,
  }
}

export type Oauth2ClientType = ReturnType<typeof Oauth2Client>
